import React from "react";
import { Modal } from "react-bootstrap";
import TableComponent from "../../../../_metronic/table/TableComponent";

const FreeDetailsModal = ({
  setShowDetails,
  showDetails,
  entities,
  setDetails,
  setOrderId,
  setSelectedUser,
}) => {
  const data = React.useMemo(() => entities, [entities]);
  const columns = React.useMemo(
    () => [
      {
        Header: "#",
        accessor: (row, index) => (
          <div className="d-flex align-items-center pl-4">
            <div>
              <h4 className="text-dark-75 font-weight-bolder mb-1 font-size-sm">
                {index + 1}
              </h4>
            </div>
          </div>
        ),
        minWidth: 50,
        width: 50,
      },
      {
        Header: "invoice no",
        accessor: "invoice_no",
        paddingLeft: "0px",
      },
      {
        Header: "customer name",
        accessor: "customer_name",
        paddingLeft: "0px",
      },
      {
        Header: "store name",
        accessor: "store_name",
        paddingLeft: "0px",
      },
      {
        Header: "phone",
        accessor: "phone",
        paddingLeft: "0px",
      },
      {
        Header: "Action",
        paddingLeft: "0px",
        width: 160,
        minWidth: 160,
        Cell: ({ row }) => (
          <>
            <button
              onClick={() => {
                // setSelectedData(row.original);
                // setProductId(row?.original?.product_id);
                setShowDetails(false);
                setDetails(true);
                setOrderId(row?.original?.orderId);
                setSelectedUser(row?.original);
              }}
              className="btn btn-primary mr-2"
            >
              <i className="fas fa-eye p-0 m-0" />
            </button>
          </>
        ),
      },
    ],
    [entities]
  );

  return (
    <Modal
      show={showDetails}
      onHide={() => setShowDetails(false)}
      size="xl"
      aria-labelledby="example-modal-sizes-title-lg"
      centered
    >
      {/* Base Products */}
      <div className="card card-custom">
        <TableComponent
          data={data}
          columns={columns}
          lists={entities}
          title="free product order list"
          hideAddButton={true}
        />
      </div>
    </Modal>
  );
};

export default FreeDetailsModal;
